import { decorate, observable} from 'mobx';
import { loginUrl } from './APIEndpoints';
import {isBlank} from './Util';


export default class LoginStore {
    loginCredentials = {
        email: '',
        password: '',
        client_name: 'pubkit',
        microsite: 'kli'
    };

    constructor(props) {
        this.apiProxy = props.apiProxy
        this.appStore = props.appStore
    }

    authenticate = async () => {
        if(this.isEmptyCredentials())
        {
            return null;
        }

        try {
            // const data={user_id:1911,email:'eo_demo@newgen.co',role:'Ops',token:'8c190f302bb89acb50aa710696f913a9-36a8024cf986e5f435144037f8367f3a',name:'Editorial Dev'};
            const response = await this.apiProxy.asyncPost(loginUrl, this.loginCredentials);
            const data = await response.json();
            return data;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }

    isEmptyCredentials = () => {
        return isBlank(this.loginCredentials.email) || isBlank(this.loginCredentials.password)
    }
}

decorate(LoginStore, {
    loginCredentials: observable,
})
